import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    this.update()
  }

  update() {
    const activeIndex = this.tabTargets.findIndex(radio => radio.checked)
    const current = activeIndex === -1 ? 0 : activeIndex

    this.panelTargets.forEach((panel, index) => {
      const isActive = index === current
      panel.classList.toggle('active', isActive)
    })
  }
}
